document.addEventListener("DOMContentLoaded", function () {
  function getCurrentEnvironment() {
    const currentHost = window.location.hostname;
    const currentUrl = window.location.href;
    const shopDomain = window.shopDomain || currentHost;

    // Map each configured store URL to its store id + test flag.
    const ts = window.themeSettings || {};
    const urlStoreMap = [
      { url: ts.test_ch_store_url, store: "chf", isTest: true },
      { url: ts.test_eu_store_url, store: "eur", isTest: true },
      { url: ts.test_gbp_store_url, store: "gbp", isTest: true },
      { url: ts.ch_store_url, store: "chf", isTest: false },
      { url: ts.eu_store_url, store: "eur", isTest: false },
      { url: ts.gbp_store_url, store: "gbp", isTest: false },
    ];

    if (currentHost.includes("myshopify.com")) {
      for (const entry of urlStoreMap) {
        if (entry.url && currentUrl.includes(new URL(entry.url).hostname)) {
          return { isTest: entry.isTest, store: entry.store };
        }
      }
    }

    // Fallback: match window.shopDomain against the configured hostnames.
    if (shopDomain) {
      for (const entry of urlStoreMap) {
        if (entry.url && shopDomain === new URL(entry.url).hostname) {
          return { isTest: entry.isTest, store: entry.store };
        }
      }
    }

    return { isTest: false, store: "unknown" };
  }

  function handleCrossStoreCountrySelection(event) {
    event.preventDefault();
    const link = event.currentTarget;
    const countryCode = link.getAttribute("data-value");
    const targetStore = link.getAttribute("data-store");
    const requiresRedirect =
      link.getAttribute("data-requires-redirect") === "true";

    console.log("[NILE-DEBUG] crossStore link click", {
      countryCode,
      targetStore,
      requiresRedirect,
      host: window.location.hostname,
    });

    const isModalContext = link.closest(".language-modal-container") !== null;

    if (isModalContext) {
      return;
    }

    if (countryCode && window.updateCountryOnly) {
      try {
        window.updateCountryOnly(countryCode);
      } catch (error) {
        console.error("Error updating Klaviyo country:", error);
      }
    }

    if (requiresRedirect) {
      const currentPath = window.location.pathname;
      // Preserve the current page across stores (product/collection/page). Strip
      // a leading language segment only when it is a full path segment (followed
      // by "/" or end) so handles like "/engraved" are kept. If the page does not
      // exist on the target store it 404s, and the 404 fallback in theme.liquid
      // sends the visitor to the homepage.
      let pathWithoutLang = currentPath.replace(/^\/(?:fr|it|en)(?=\/|$)/, "");
      if (pathWithoutLang && !pathWithoutLang.startsWith("/")) {
        pathWithoutLang = "/" + pathWithoutLang;
      }
      if (pathWithoutLang === "/") {
        pathWithoutLang = "";
      }

      let currentLang = (window.shopDefaultLocale || "de").toLowerCase();
      if (currentPath.startsWith("/en")) {
        currentLang = "en";
      } else if (currentPath.startsWith("/fr")) {
        currentLang = "fr";
      } else if (currentPath.startsWith("/it")) {
        currentLang = "it";
      }

      const currentEnv = getCurrentEnvironment();
      let targetUrl;

      if (currentEnv.isTest) {
        if (targetStore === "eur") {
          targetUrl = window.themeSettings.test_eu_store_url;
        } else if (targetStore === "gbp") {
          targetUrl = window.themeSettings.test_gbp_store_url;
        } else {
          targetUrl = window.themeSettings.test_ch_store_url;
        }
      } else {
        if (targetStore === "eur") {
          targetUrl = window.themeSettings.eu_store_url;
        } else if (targetStore === "gbp") {
          targetUrl = window.themeSettings.gbp_store_url;
        } else {
          targetUrl = window.themeSettings.ch_store_url;
        }
      }

      if (!targetUrl) {
        console.error(
          "Target store URL not configured for store:",
          targetStore,
        );
        return;
      }

      if (targetUrl.endsWith("/")) {
        targetUrl = targetUrl.slice(0, -1);
      }

      // Resolve the language for the TARGET store. Each store serves its default
      // locale at the root (no prefix); the GBP store is English-only.
      const storeDefaultLocale = { chf: "de", eur: "de", gbp: "en" };
      const targetDefaultLang = storeDefaultLocale[targetStore] || "de";
      // Carry the user's current language across the store boundary. The target
      // store's LanguageEnforcement (via modal_language below) applies it only if
      // that store actually publishes it, so we don't force a value here.
      let targetLang = currentLang;

      // Prefix a language only for stores known to publish de/en/fr/it (chf/eur).
      // gbp's locale set is not assumed: keep the bare path (its default language)
      // and let modal_language upgrade it if published — avoids a /<lang> 404 when
      // that language is not published on gbp.
      let finalPath = pathWithoutLang === "/" ? "" : pathWithoutLang;
      if (targetStore !== "gbp" && targetLang !== targetDefaultLang) {
        finalPath =
          finalPath === "" ? `/${targetLang}` : `/${targetLang}${finalPath}`;
      }

      if (finalPath && !finalPath.startsWith("/")) {
        finalPath = "/" + finalPath;
      }

      // =====================================================
      // SET COOKIE before redirect via NileCountryRedirect
      // =====================================================
      if (window.NileCountryRedirect) {
        window.NileCountryRedirect.setNilePrefs({
          country: countryCode,
          language: targetLang,
          store: targetStore,
        });
      }

      const url = new URL(targetUrl + (finalPath || "/"));
      url.searchParams.set("redirected", "true");
      url.searchParams.set("country", countryCode);
      // Tell the target store which language to use. Its LanguageEnforcement reads
      // modal_language and applies it, overriding that store's own stale per-domain
      // localStorage (which otherwise reverts the language after the redirect).
      if (targetLang) {
        url.searchParams.set("modal_language", targetLang);
      }
      let finalRedirectUrl = url.toString();

      if (finalRedirectUrl.endsWith("/")) {
        finalRedirectUrl = finalRedirectUrl.slice(0, -1);
      }

      console.log("[NILE-DEBUG] crossStore -> window.open", {
        targetStore,
        currentEnv,
        targetUrl,
        finalRedirectUrl,
      });
      window.open(finalRedirectUrl, "_self");
    }
  }
  function initializeCrossStoreLinks() {
    const crossStoreLinks = document.querySelectorAll(
      ".cross-store-link[data-requires-redirect='true']",
    );
    crossStoreLinks.forEach((link) => {
      link.addEventListener("click", handleCrossStoreCountrySelection);
    });
  }
  function handleCountryPreselection() {
    const urlParams = new URLSearchParams(window.location.search);
    const redirectedCountry = urlParams.get("country");
    if (redirectedCountry) {
      const countryLink = document.querySelector(
        `[data-value="${redirectedCountry}"]`,
      );
      if (countryLink) {
        const button = document.querySelector(
          ".disclosure__button span:last-child",
        );
        if (button) {
          const countryName = countryLink.querySelector(".country").textContent;
          button.textContent = countryName;
        }
        const countryInput = document.querySelector(
          'input[name="country_code"]',
        );
        if (countryInput) {
          countryInput.value = redirectedCountry;
        }
      }
      const newUrl = new URL(window.location);
      newUrl.searchParams.delete("redirected");
      newUrl.searchParams.delete("country");
      window.history.replaceState({}, "", newUrl);
    }
  }
  function init() {
    initializeCrossStoreLinks();
    handleCountryPreselection();
  }
  init();
});
